export const environment = {
  name: 'Test', 
  apiV2: 'https://yourlandlordapitest2.azurewebsites.net/api/v2',
  token: 'https://yourlandlordapitest2.azurewebsites.net/token',
  production: false,
  hasEInvoiceB2CEnabled: false,
  // Global search formatting toggles (test default: raw API to compare)
  globalSearchEnableExperimental: false,
  globalSearchFormatMode: 'api-raw',
};
